export default "__VITE_ASSET__DeYSBW2Y__"